<template>
  <canvas ref="chart" height="350" />
</template>
<script>
import { Chart } from 'chart.js'

export default {
  props: ['data', 'options', 'backgroundColor', 'legendPosition'],
  data: () => {
    return {
      chart: null,
    }
  },
  watch: {
    data: {
      handler(newData) {
        this.chart.data = this.generateData(newData)
        this.chart.update()
      },
    },
  },
  mounted() {
    const ctx = this.$refs.chart.getContext('2d')
    this.chart = new Chart(ctx, {
      type: 'pie',
      data: this.generateData(this.data),
      options: {
        ...this.options,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: this.options.displayLegend,
            position: this.legendPosition || 'right',
            labels: {
              pointStyle: true,
              boxWidth: 8,
              boxHeight: 8,
              usePointStyle: 'circle',
              font: 'Source Sans Pro',
            },
          },
          tooltip: {
            displayColors: false,
            callbacks: {
              title: function (_) {
                return null
              },
              label: function (context) {
                return context.dataset.tooltipLabels
                  ? context.dataset.tooltipLabels[context.dataIndex].split('|')
                  : context.formattedValue
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
              drawBorder: false,
              title: false,
            },
            ticks: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
              drawBorder: false,
              title: false,
            },
            ticks: {
              display: false,
            },
          },
        },
      },
    })
  },
  methods: {
    generateData(data) {
      return {
        ...data,
        datasets: data.datasets.map(set => ({
          backgroundColor: ['#F9D7CE', '#CEE4F2'],
          hoverBackgroundColor: ['#F9D7CE', '#CEE4F2'],
          hoverOffset: 10,
          ...set,
        })),
      }
    },
  },
}
</script>
